const STAFF_GROUP = Object.freeze({
  all: 'all',
  salon: 'salon',
  employed: 'employed',
  self: 'self',
  single: 'single',
});

// noinspection JSUnusedGlobalSymbols
export default STAFF_GROUP;
